export enum Channel {
  TLN = 1,
  TERRAVITA = 2,
  EIYOLAB = 3,
  B2B = 4,
  BOUTIQUES = 5,
  AMAZON = 6,
  REAPPROBOUTIQUES = 7,
}

export const ChannelTranslations: Record<Channel, string> = {
  [Channel.TLN]: 'Toutelanutrition',
  [Channel.TERRAVITA]: 'Terravita',
  [Channel.EIYOLAB]: 'Eiyolab',
  [Channel.B2B]: 'BtoB',
  [Channel.BOUTIQUES]: 'Boutiques',
  [Channel.AMAZON]: 'Amazon',
  [Channel.REAPPROBOUTIQUES]: 'ReapproBoutique',
};

export const ChannelSelects = (Object.keys(ChannelTranslations) as unknown as Channel[]).map((channel) => ({
  value: channel,
  label: ChannelTranslations[channel],
}));
